import { render, staticRenderFns } from "./packageInfoForm.vue?vue&type=template&id=76c9f8f0&"
import script from "./packageInfoForm.vue?vue&type=script&lang=js&"
export * from "./packageInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./packageInfoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76c9f8f0')) {
      api.createRecord('76c9f8f0', component.options)
    } else {
      api.reload('76c9f8f0', component.options)
    }
    module.hot.accept("./packageInfoForm.vue?vue&type=template&id=76c9f8f0&", function () {
      api.rerender('76c9f8f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/OMS/components/Order/packageInfoForm.vue"
export default component.exports